import React, { useEffect, useMemo, useState } from 'react';
import { CombustibleService } from '../services/combustibleService';
import { AutosService } from '../services/autosService';
import './ReporteCombustible.css';

const ReporteCombustible = () => {
  const [consumos, setConsumos] = useState([]);
  const [vehiculos, setVehiculos] = useState([]);
  const [areaFiltro, setAreaFiltro] = useState(''); // '', 'reparto' | 'proveedor' | 'empleado'

  useEffect(() => {
    const unsub = CombustibleService.suscribirseRegistros(setConsumos);
    const unsubAutos = AutosService.suscribirseAutos(setVehiculos);
    return () => { if (typeof unsub === 'function') unsub(); if (typeof unsubAutos === 'function') unsubAutos(); };
  }, []);

  const getVehiculoLabel = (v) => {
    if (!v) return '';
    let label = v.placas ? `${v.placas} - ${v.marca || ''} ${v.modelo || ''}`.trim() : (v.nombre || v.id);
    if (v.areaVehicular === 'proveedor') label = `${v.nombreProveedor || 'Proveedor'} (${v.telefonoProveedor || '—'})`;
    if (v.areaVehicular === 'empleado') label = `${v.nombreEmpleado || 'Empleado'} (${v.numeroEmpleado || '—'})`;
    return label;
  };

  const coincideArea = (registro) => {
    if (!areaFiltro) return true;
    const veh = vehiculos.find(v => getVehiculoLabel(v) === (registro.vehiculo || registro.placas));
    return veh ? veh.areaVehicular === areaFiltro : false;
  };

  const tabla = useMemo(() => {
    return [...consumos].filter(coincideArea).sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
  }, [consumos, vehiculos, areaFiltro]);

  // (Se eliminó la gráfica inferior por solicitud)

  // Exportación a Excel (CSV simple)
  const exportarExcel = (rows) => {
    const encabezados = ['Fecha','Vehículo','Chofer','Km Inicial','Km Final','Km Recorridos','Litros','Rendimiento','Monto'];
    const csvRows = rows.map(c => [
      new Date(c.fecha || c.fechaRegistro || c.timestamp).toISOString().slice(0,10),
      c.vehiculo || c.placas || '-',
      c.chofer || 'N/A',
      c.kilometrajeInicial ?? '',
      c.kilometrajeFinal ?? '',
      c.kilometrosRecorridos ?? '',
      c.litrosConsumidos ?? '',
      c.rendimiento ?? '',
      c.monto ?? ''
    ]);
    const escape = (v) => {
      const s = String(v ?? '');
      return (s.includes(',') || s.includes('\n') || s.includes('"')) ? '"' + s.replace(/"/g, '""') + '"' : s;
    };
    const csv = [encabezados, ...csvRows].map(r => r.map(escape).join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `combustible_gerente_${new Date().toISOString().slice(0,10)}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="reporte-combustible">
      <div className="table-container">
        <div className="section-header">
          <h2>Registros de Combustible ({tabla.length})</h2>
          <div>
            <button className="btn-exportar" onClick={() => exportarExcel(tabla)}>Exportar Excel</button>
            <button className="btn-exportar" onClick={() => CombustibleService.exportarPDF(tabla)}>Exportar PDF</button>
          </div>
        </div>
        <div className="filtros-grid">
          <div className="filter-group">
            <label>Área vehicular:</label>
            <select value={areaFiltro} onChange={(e) => setAreaFiltro(e.target.value)}>
              <option value="">Todas</option>
              <option value="reparto">Unidades de reparto</option>
              <option value="proveedor">Proveedores</option>
              <option value="empleado">Empleados</option>
            </select>
          </div>
        </div>
        <div className="table-responsive">
          <table className="ordenes-table">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Vehículo</th>
                <th>Chofer</th>
                <th>Km Inicial</th>
                <th>Km Final</th>
                <th>Km Recorridos</th>
                <th>Litros</th>
                <th>Rendimiento</th>
                <th>Monto</th>
              </tr>
            </thead>
            <tbody>
              {tabla.length === 0 ? (
                <tr>
                  <td colSpan="9" style={{ textAlign: 'center', padding: '3rem', color: '#94a3b8' }}>
                    No hay registros de combustible disponibles
                  </td>
                </tr>
              ) : (
                tabla.map(c => (
                  <tr key={c.id}>
                    <td>{new Date(c.fecha || c.fechaRegistro || c.timestamp).toLocaleDateString('es-MX')}</td>
                    <td>{c.vehiculo || c.placas || '-'}</td>
                    <td>{c.chofer || 'N/A'}</td>
                    <td>{c.kilometrajeInicial ? Number(c.kilometrajeInicial).toLocaleString() : 'N/A'}</td>
                    <td>{c.kilometrajeFinal ? Number(c.kilometrajeFinal).toLocaleString() : 'N/A'}</td>
                    <td>{c.kilometrosRecorridos ? Number(c.kilometrosRecorridos).toLocaleString() : 'N/A'}</td>
                    <td>{c.litrosConsumidos ?? 'N/A'}</td>
                    <td>{c.rendimiento ?? '0'} km/l</td>
                    <td>{Number(c.monto || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ReporteCombustible;


